import { Injectable } from '@angular/core';
import { Params, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class QueryParamService {

  public refid: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public sfrecid: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public leadid: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public branch: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public loantype: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public token: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public mortgageId: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public borrowerPosition: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public leadsource: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public distinct_id: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public i3id: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public ldec: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public partnerName: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public ppon: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public loanid: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  constructor(
    router: Router
  ) {

    // @NOTE ActivatedRoute is initialized AFTER `canActivate()`s
    // are resolved and rerouting has begun,
    // so we cannot use it's queryParam listener ...
    // to catch ALL initial queryParams, listen to Router.events
    router.events.subscribe((navigation: any = {}) => {
      const params: Params = router.parseUrl(navigation.url).queryParams;
      this.handleHistoricParams(params);
    });
  }

  private handleHistoricParams(params: Params): void {
    this.update(this.refid, params, 'refid');
    this.update(this.leadid, params, 'leadid');
    this.update(this.branch, params, 'branch');
    this.update(this.loantype, params, 'loantype');
    this.update(this.token, params, 'token');
    this.update(this.leadsource, params, 'leadsource');
    this.update(this.distinct_id, params, 'distinct_id');
    this.update(this.i3id, params, 'i3id');
    this.update(this.sfrecid, params, 'sfrecid');
    this.update(this.ldec, params, 'ldec');
    this.update(this.partnerName, params, 'partnerName');
    this.update(this.ppon, params, 'ppon');
    // CLPBP-34
    this.update(this.loanid, params, 'loanId');
  }

  private update = (subject: BehaviorSubject<string>, params: Params, s: string) => {
    if (params[s]) {
      subject.next(params[s]);

      if (s === 'ppon') {
        this.setCookie('ppon', params[s], 90);
      }
    }
  }

  private setCookie(cookieName: string, cookieValue: string, daysUntilExpiration: number): void {
    const date = new Date();
    date.setTime(date.getTime() + (daysUntilExpiration * 24 * 60 * 60 * 1000));
    const expires = 'expires=' + date.toUTCString();
    document.cookie = cookieName + '=' + cookieValue + ';' + expires + ';path=/';
  }
}
